import {
  ADD_TO_COMPARE,
  REMOVE_FROM_COMPARE,
  CLEAR_COMPARE,
  ADD_COMPARE_INSIGHT,
  INITIALISE_COMPARE_INSIGHT,
  SET_COMPARE_LOADING,
  SET_COMPARE_ERROR,
  CompareAction,
  CompareState,
  initialState, ADD_TO_COMPARE_WITH_INSIGHT,
} from "./types";

export const compareReducer = (
  state: CompareState,
  action: CompareAction
): CompareState => {

  switch (action.type) {

    case ADD_TO_COMPARE: {

      // Check whether the audience exists
      const exists = state.comparisonAudiences.some(
        (audience) => audience.audience_id === action.payload.audience.audience_id
      )

      // Set the new insights
      const initialInsights = {
        audience_id: action.payload.audience.audience_id,
        loading: true
      }

      // If it doesn't then add it at the given index if provided
      if (!exists) {
        if (action.payload.index !== undefined) {

          // Clamp the index
          const index = Math.min(Math.max(action.payload.index, 0), state.comparisonAudiences.length);

          // Update the audience list
          const updatedAudiences = [
            ...state.comparisonAudiences.slice(0, index),
            action.payload.audience,
            ...state.comparisonAudiences.slice(index)
          ]

          // Reset the insight too
          const updatedInsights = [
            ...state.comparisonInsights.slice(0, index),
            initialInsights,
            ...state.comparisonInsights.slice(index)
          ]

          return {
            ...state,
            comparisonAudiences: updatedAudiences,
            comparisonInsights: updatedInsights
          }
        } else {
          return {
            ...state,
            comparisonAudiences: [...state.comparisonAudiences, action.payload.audience],
            comparisonInsights: [...state.comparisonInsights, initialInsights]
          }
        }
      } else {
        return state;
      }
    }

    case ADD_TO_COMPARE_WITH_INSIGHT:
      return {
        ...state,
        comparisonAudiences: [action.payload.audience],
        comparisonInsights: [action.payload.insight]
      }

    case REMOVE_FROM_COMPARE: {
      // Get the index of the audience
      const audienceIndex = state.comparisonAudiences.findIndex(
        (audience) => audience.audience_id === action.payload.audience_id
      );

      // Remove the audience using the index
      const updatedAudiences = [...state.comparisonAudiences];
      updatedAudiences.splice(audienceIndex, 1);

      // Remove the same audience's insights
      const updatedInsights = [...state.comparisonInsights];
      updatedInsights.splice(audienceIndex, 1);

      return {
        ...state,
        comparisonAudiences: updatedAudiences,
        comparisonInsights: updatedInsights,
      };
    }
    case CLEAR_COMPARE:
      return initialState;

    case SET_COMPARE_LOADING:
      return { ...state, loading: action.payload };

    case SET_COMPARE_ERROR:
      return { ...state, error: action.payload };

    case INITIALISE_COMPARE_INSIGHT: {

      const initialInsight = {
        audience_id: action.payload.audience_id,
        loading: true
      }

      const updatedInsights = state.comparisonInsights.map(
        (insight, idx) =>
          idx === action.payload.index ? initialInsight : insight
      );

      return {
        ...state,
        comparisonInsights: updatedInsights
      }
    }

    case ADD_COMPARE_INSIGHT:
      if (action.payload.index !== undefined) {

        // Clamp the index
        const index = Math.min(Math.max(action.payload.index, 0), state.comparisonInsights.length);

        // const updatedInsights = [
        //   ...state.comparisonInsights.slice(0, index),
        //   action.payload.insight,
        //   ...state.comparisonInsights.slice(index)
        // ]
        const updatedInsights = state.comparisonInsights.map(
          (insight, idx) =>
            idx === index ? action.payload.insight : insight
        );

        return {
          ...state,
          comparisonInsights: updatedInsights
        }

      } else {
        return {
          ...state,
          comparisonInsights: [...state.comparisonInsights, action.payload.insight],
        };
      }

    default:
      return state;
  }
};
